import moment from 'moment';
import { IconNames } from '@shipengine/giger-theme';
import { Icon, Typography } from '@shipengine/giger';
import { useTranslation } from '@packlink/translation-provider';
import { getRouteSectionStyles, getRouteTitleWrapperStyles, getRouteIconStyles, getRouteLinkButtonStyles, getRouteTimeStyles, getRouteCaptionStyles } from '../RouteStyles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';

const Collection = _ref => {
  let {
    collection: {
      date,
      dropOff
    },
    timeLeftToBook,
    onToggleDropOffPoints
  } = _ref;
  const {
    t
  } = useTranslation();
  const [collectionType, collectionIcon] = ['collection', IconNames.HOUSE];
  let caption = t('service-card.collection.dropoff');
  if (!dropOff && timeLeftToBook) {
    const timeToBookType = t(`service-card.date.${timeLeftToBook.type.toLowerCase()}`);
    caption = t('service-card.collection.pick-up', {
      book_time: `${timeLeftToBook.value} ${timeToBookType.toLowerCase()}`
    });
  }
  return jsxs("section", {
    css: getRouteSectionStyles,
    children: [jsxs("div", {
      css: getRouteTitleWrapperStyles,
      children: [jsx(Icon, {
        css: getRouteIconStyles,
        name: dropOff ? IconNames.MARKER : collectionIcon
      }), jsx(Typography, {
        variant: "subtitle2",
        children: t(`service-card.collection-type.${dropOff ? 'drop-off' : collectionType}`)
      })]
    }), dropOff ?
    // Service Card will suffer a style change in 2022Q2
    // we will keep this "anomaly" until that
    // this must be a Button
    jsx(Typography, {
      href: "#",
      component: "a",
      role: "button",
      variant: "small",
      css: getRouteLinkButtonStyles,
      onClick: onToggleDropOffPoints,
      children: t('service-card.drop-off.see-map')
    }) : jsx(Typography, {
      variant: "small",
      css: getRouteTimeStyles,
      children: jsx("time", {
        dateTime: moment(date).format(moment.HTML5_FMT.DATETIME_LOCAL),
        children: date.format('ddd, MMMM DD')
      })
    }), jsx(Typography, {
      variant: "small",
      css: getRouteCaptionStyles,
      children: jsx("p", {
        children: caption
      })
    })]
  });
};

export { Collection };
//# sourceMappingURL=Collection.js.map
